export function headerHeight() {
    const siteHeader = document.querySelector('.site-header');
    const headerHeight = siteHeader.offsetHeight;


    
    // Set the CSS variables with the heights
    document.documentElement.style.setProperty('--padding-header-height', `${headerHeight}px`);
  }
  